import React, { useEffect, useState } from 'react';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Rating from '@mui/material/Rating';
import Paper from '@mui/material/Paper';
import BtnComponent from '../buttonComponent/BtnComponent';
import StatusIcon from '@mui/icons-material/FiberManualRecord';
import { fetchStatusObj } from '../../shared/helper';
import Tooltip from '@mui/material/Tooltip';
import Avatar from '@mui/material/Avatar';
import { Box } from '@mui/system';
import { Typography } from '@mui/material';
import PaginationComponent from '../paginationComponent/PaginationComponent';
import DownloadIcon from '@mui/icons-material/Download';
import SecondaryBtnComponent from '../buttonComponent/SecondaryBtnComponent';
import avataricon from '../../assests/avataricon.svg';
import VideoCallIcon from '@mui/icons-material/VideoCall';
import { DEFAULT_NULL_REPLACEMENT } from '../../shared/constants';
import TextsmsIcon from '@mui/icons-material/Textsms';
import CallIcon from '@mui/icons-material/Call';

const statusColumn = {
  display: 'flex',
  alignItems: 'center',
};

const statusIcon = {
  display: 'flex',
  height: 12,
  width: 12,
  marginRight: 4,
};
const avatar = {
  height: 20,
  width: 20,
  marginRight: 1,
};
const tooltip = {
  padding: 0,
  background: '#1B1B1B',
  minWidth: 98,
  position: 'relative',
  bottom: 5,
  height: 20,
};

const dataSource = {
  background: '#E4E4E4',
  border: '1px solid #C0C0C0',
  boxSizing: 'border-box',
  borderRadius: '8px',
  color: '#1F1F1F',
  fontWeight: 500,
  fontSize: '11px',
  lineHeight: '16px',
  textAlign: 'center',
  width: 98,
  padding: '3px 2px',
  display: 'inline-block',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  position: 'relative',
  top: '3px',
};

const tooltipDisplay = {
  background: '#1B1B1B',
  color: '#FFFFFF',
  boxSizing: 'border-box',
  borderRadius: '4px',
  fontWeight: 400,
  fontSize: '14px',
  lineHeight: '20px',
  textAlign: 'center',
  padding: '0px 8px 6px 8px',
  minWidth: 98,
  display: 'block',
  position: 'relative',
  top: 2,
};
const paginationWrapper = {
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  marginTop: 18,
};

const container = {
  borderRadius: 6,
  border: '1px solid #E4E4E4',
  bgcolor: '#F5F5F5',
};

const tableConatiner = {
  width: '100%',
  bgcolor: '#FFFFFF',
};

const OpenButton = {
  flex: 0.8,
  height: 24,
  width: '100px',
  boxSizing: 'border-box',
  fontSize: 12,
  padding: '2px 4px 2px 6px',
};
const viewButton = {
  flex: 0.8,
  height: 24,
  width: '100px',
  boxSizing: 'border-box',
  fontSize: 12,
  padding: '2px 4px 2px 6px',
};
const viewPriceButton = {
  flex: 0.8,
  height: 24,
  width: '100px',
  boxSizing: 'border-box',
  fontSize: 12,
  padding: '2px 4px 2px 6px',
};

const consentBox = {
  padding: '0px 8px',
  bgcolor: '#E4E4E4',
  textAlign: 'center',
  borderRadius: '24px',
  border: '1px solid',
  width: '140px',
  textTransform: 'uppercase',
  fontWeight: '500',
  fontSize: 9,
  boxSizing: 'border-box',
};

const orgNameContainer = {
  background: '#E4E4E4',
  border: '1px solid #C0C0C0',
  boxSizing: 'border-box',
  borderRadius: '24px',
  color: '#1F1F1F',
  fontWeight: 500,
  fontSize: '11px',
  lineHeight: '16px',
  textAlign: 'start',
  padding: '4px 8px',
  display: 'inline-block',
  // whiteSpace: 'nowrap',
  // overflow: 'hidden',
  // textOverflow: 'ellipsis',
  // position: 'relative',
  top: '3px',
};

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  flex: 1,

  [`&.${tableCellClasses.head}`]: {
    fontWeight: 600,
    fontSize: 14,
    color: '#333333',
    opacity: 1,
    minWidth: 120,
    maxWidth: '100%',
    padding: '14px 16px 14px 14px',
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    minWidth: 120,
    overflow: 'hidden',
    maxWidth: '100%',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    padding: '14px 16px 14px 14px',
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  display: 'flex',
  minWidth: '100%',
  '&:last-child td, &:last-child th': {
    border: 0,
    height: 'auto',
  },
}));

const renderStatusView = status => {
  let statusObj;

  if (status === '-') {
    statusObj = {
      status: '-',
      color: '#fff',
    };
  } else {
    statusObj = fetchStatusObj(status);
  }
  return (
    <Box style={{ display: 'flex', alignItems: 'center' }}>
      <Box style={statusColumn}>
        <StatusIcon htmlColor={statusObj.color} style={statusIcon} />
      </Box>
      {statusObj.status}
    </Box>
  );
};

const renderDataSourceColumn = val => {
  let showToolTip = false;
  if (val && val.length > 12) {
    showToolTip = true;
  }

  const toolTipHtml = partnerName => {
    return <Box sx={tooltipDisplay}>{partnerName}</Box>;
  };

  return showToolTip ? (
    <Tooltip arrow title={toolTipHtml(val)} sx={tooltip}>
      <Box
        sx={{
          background: '#E4E4E4',
          border: '1px solid #C0C0C0',
          boxSizing: 'border-box',
          borderRadius: '8px',
          color: '#1F1F1F',
          fontWeight: 500,
          fontSize: '11px',
          lineHeight: '16px',
          textAlign: 'center',
          width: 98,
          padding: '3px 2px',
          display: 'inline-block',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          position: 'relative',
          top: '3px',
        }}>
        {val.substring(0, 11)}
      </Box>
    </Tooltip>
  ) : (
    <Box
      sx={{
        background: '#E4E4E4',
        border: '1px solid #C0C0C0',
        boxSizing: 'border-box',
        borderRadius: '8px',
        color: '#1F1F1F',
        fontWeight: 500,
        fontSize: '11px',
        lineHeight: '16px',
        textAlign: 'center',
        width: 98,
        padding: '3px 2px',
        display: 'inline-block',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        // textOverflow: 'ellipsis',
        // position: 'relative',
        top: '3px',
      }}>
      {val}
    </Box>
  );
};

const renderOrgNameColumn = val => {
  let showToolTip = false;
  if (val && val.length > 12) {
    showToolTip = true;
  }

  const toolTipHtml = partnerName => {
    return (
      <Box
        sx={{
          boxSizing: 'border-box',
          fontWeight: 400,
          fontSize: '14px',
          lineHeight: '20px',
          textAlign: 'start',
          padding: '0px 8px 6px 8px',
          minWidth: 98,
          display: 'block',
          position: 'relative',
          top: 2,
        }}>
        {partnerName}
      </Box>
    );
  };

  return showToolTip ? (
    <Tooltip arrow title={toolTipHtml(val)} sx={tooltip}>
      <Box sx={orgNameContainer}>{val.substring(0, 11)}</Box>
    </Tooltip>
  ) : (
    <Box sx={orgNameContainer}>{val}</Box>
  );
};

const renderAssessmentNameColumn = val => {
  let showToolTip = false;
  if (val && val.length > 12) {
    showToolTip = true;
  }

  const toolTipHtml = partnerName => {
    return (
      <Box
        sx={{
          boxSizing: 'border-box',
          fontWeight: 400,
          fontSize: '14px',
          lineHeight: '20px',
          textAlign: 'start',
          padding: '0px 8px 6px 8px',
          minWidth: 98,
          display: 'block',
          position: 'relative',
          top: 2,
        }}>
        {partnerName}
      </Box>
    );
  };

  return showToolTip ? (
    <Tooltip
      arrow
      title={toolTipHtml(val)}
      sx={{
        padding: 0,
        background: '#1B1B1B',
        minWidth: 98,
        position: 'relative',
        bottom: 5,
        height: 20,
      }}>
      <Box
        sx={{
          boxSizing: 'border-box',
          color: '#1F1F1F',
          fontWeight: 400,
          fontSize: '14px',
          lineHeight: '16px',
          padding: '4px 8px',
          textAlign: 'start',
          display: 'inline-block',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          position: 'relative',
          top: '3px',
        }}>
        {val?.substring(0, 11)}...
      </Box>
    </Tooltip>
  ) : (
    <Box
      sx={{
        boxSizing: 'border-box',
        color: '#1F1F1F',
        fontWeight: 500,
        fontSize: '14px',
        lineHeight: '16px',
        textAlign: 'start',
        padding: '4px 8px',
        display: 'inline-block',
        whiteSpace: 'nowrap !important',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        position: 'relative',
        top: '3px',
        borderRadius: '24px',
      }}>
      {val}
    </Box>
  );
};

const renderAvatarView = (iconlink, value) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
      }}>
      <Box style={statusColumn}>
        <Avatar src={iconlink || avataricon} sx={avatar} />
        {value}
      </Box>
    </Box>
  );
};

const renderDownload = (download, setSnackbar) => {
  const handleClick = () => {
    if (download !== DEFAULT_NULL_REPLACEMENT) {
      setSnackbar(true);
      window.open(download, '_blank');
    }
  };

  return (
    <BtnComponent
      onClick={handleClick}
      title="Open"
      sx={OpenButton}></BtnComponent>
  );
};

const renderVideoLink = () => {
  return (
    <Box
      sx={{
        background: '#E4E4E4',
        width: '32px',
        height: '32px',
        borderRadius: '16px',
      }}>
      <VideoCallIcon sx={{ mt: '5px', ml: '4px', color: '#4B4B4B' }} />
    </Box>
  );
};

const renderContactCareTeam = item => {
  return <Box>{item === 'Text' ? <TextsmsIcon /> : <CallIcon />}</Box>;
};

const renderRating = value => {
  return (
    <Box>
      <Rating
        name="half-rating-read"
        defaultValue={4.5}
        precision={0.5}
        readOnly
      />
    </Box>
  );
};

const ReusableTable = ({
  tableHeading,
  data,
  viewDetailsHandler,
  showVideoIcon = false,
  viewPriceHandler,
  numberOfRowsPerPage = 10,
  showPagination = true,
  isAssessment = false,
  setSnackbar,
  cellWidth,
  field,
  handleAssessmentButtonClick,
}) => {
  const [tableBodyData, setTableData] = useState(data);

  useEffect(() => {
    setTableData(data);
  }, [data]);

  return (
    <>
      <TableContainer component={Paper} sx={container} data-testid="table">
        <Table sx={tableConatiner} aria-label="customized table">
          <TableHead sx={{ borderBottom: '0.5px solid #D0D0D0' }}>
            <StyledTableRow>
              {tableHeading?.map((heading, index) => {
                if (heading.label === 'More') {
                  return (
                    <StyledTableCell
                      key={index}
                      sx={{ textAlign: 'right' }}></StyledTableCell>
                  );
                } else if (heading.label === 'Download') {
                  return (
                    <StyledTableCell
                      key={index}
                      sx={{ textAlign: 'right' }}></StyledTableCell>
                  );
                }
                if (heading['hide'] === undefined || heading.hide === false) {
                  return (
                    <StyledTableCell component="th" scope="row" key={index}>
                      {heading.label}
                    </StyledTableCell>
                  );
                }
                return '';
              })}
            </StyledTableRow>
          </TableHead>
          <TableBody>
            {tableBodyData?.map((obj, i) => (
              <StyledTableRow key={Math.random() * i}>
                {tableHeading.map((headerColumnObj, j) => {
                  if (
                    headerColumnObj['hide'] !== undefined &&
                    headerColumnObj.hide === true
                  ) {
                    return '';
                  } else if (headerColumnObj.label === 'More') {
                    return (
                      <StyledTableCell key={obj['id'] * j}>
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'space-evenly',
                            // width: '130px',
                          }}>
                          {(obj['status'] === 'ISSUED' &&
                            (obj['paymentStatus'] === 'failed' ||
                              obj['paymentStatus'] === 'pending')) ||
                          obj['paymentStatus'] === 'cancelled' ||
                          obj['paymentStatus'] === 'requires_confirmation' ? (
                            <SecondaryBtnComponent
                              sx={{
                                width: '91px',
                                height: '24px',
                                boxSizing: 'border-box',
                                fontSize: '14px',
                                p: '2px 16px 2px 16px',
                              }}
                              title="Pay Now"
                            />
                          ) : (
                            obj[headerColumnObj.key]
                          )}
                          {isAssessment ? (
                            <BtnComponent
                              onClick={() => {
                                // eslint-disable-next-line no-unused-expressions
                                viewDetailsHandler
                                  ? viewDetailsHandler(obj)
                                  : null;
                              }}
                              title={
                                ['Pending', 'IN-PROGRESS']?.includes(
                                  obj['status']
                                )
                                  ? 'Fill now'
                                  : 'View details'
                              }
                              disabled={['EXPIRED']?.includes(obj['status'])}
                              sx={viewButton}></BtnComponent>
                          ) : (
                            <BtnComponent
                              onClick={() => {
                                // eslint-disable-next-line no-unused-expressions
                                viewDetailsHandler
                                  ? viewDetailsHandler(obj)
                                  : null;
                              }}
                              title="View Details"
                              sx={viewButton}></BtnComponent>
                          )}
                        </Box>
                      </StyledTableCell>
                    );
                  } else if (
                    headerColumnObj.label === 'Recorded By' ||
                    headerColumnObj.label === 'Provided By' ||
                    headerColumnObj.label === 'Provider' ||
                    headerColumnObj.label === 'Prescriber' ||
                    headerColumnObj.label === 'Updated By'
                  ) {
                    return (
                      <StyledTableCell key={obj['id'] * j}>
                        {obj.avatarLink
                          ? renderAvatarView(
                              obj.avatarLink,
                              obj[headerColumnObj.key]
                            )
                          : obj[headerColumnObj.key] || '---'}
                      </StyledTableCell>
                    );
                  } else if (headerColumnObj.label === 'More') {
                    return (
                      <StyledTableCell key={obj['id'] * j}>
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'space-evenly',
                            width: '140px',
                            marginLeft: '-12px',
                          }}>
                          {showVideoIcon &&
                            renderVideoLink(obj[headerColumnObj.key])}

                          <BtnComponent
                            onClick={() => {
                              // eslint-disable-next-line no-unused-expressions
                              viewDetailsHandler
                                ? viewDetailsHandler(obj['id'], obj)
                                : null;
                            }}
                            title="View Details"
                            sx={viewButton}></BtnComponent>
                        </Box>
                      </StyledTableCell>
                    );
                  } else if (headerColumnObj.label === 'Price List') {
                    return (
                      <StyledTableCell key={obj['id'] * j}>
                        <SecondaryBtnComponent
                          onClick={() => {
                            // eslint-disable-next-line no-unused-expressions
                            viewPriceHandler
                              ? viewPriceHandler(obj['planId'], obj['coverage'])
                              : null;
                          }}
                          title="View Price"
                          sx={viewPriceButton}
                        />
                      </StyledTableCell>
                    );
                  } else if (headerColumnObj.label === 'Status') {
                    return (
                      <StyledTableCell key={obj['id'] * j}>
                        {renderStatusView(obj[headerColumnObj.key])}
                      </StyledTableCell>
                    );
                  } else if (headerColumnObj.label === 'Contact') {
                    return (
                      <StyledTableCell key={obj['id'] * j}>
                        {renderContactCareTeam(obj[headerColumnObj.key])}
                      </StyledTableCell>
                    );
                  } else if (headerColumnObj.label === 'Download') {
                    return (
                      <StyledTableCell key={obj['id'] * j}>
                        {renderDownload(obj['download'], setSnackbar)}
                      </StyledTableCell>
                    );
                  } else if (headerColumnObj.label === 'Data Source') {
                    return (
                      <StyledTableCell key={obj['id'] * j}>
                        {renderDataSourceColumn(obj[headerColumnObj.key])}
                      </StyledTableCell>
                    );
                  } else if (headerColumnObj.label === 'Organization name') {
                    return (
                      <StyledTableCell key={obj['id'] * j}>
                        {renderOrgNameColumn(obj[headerColumnObj.key])}
                      </StyledTableCell>
                    );
                  } else if (headerColumnObj.label === 'Name') {
                    return (
                      <StyledTableCell key={obj['id'] * j}>
                        {renderAssessmentNameColumn(obj[headerColumnObj.key])}
                      </StyledTableCell>
                    );
                  } else if (headerColumnObj.label === 'Rating') {
                    return (
                      <StyledTableCell key={obj['id'] * j}>
                        {renderRating(
                          Number(obj.rating),
                          obj[headerColumnObj.key]
                        )}
                      </StyledTableCell>
                    );
                  } else if (headerColumnObj.label === 'Type of Consent') {
                    return (
                      <StyledTableCell key={obj['id'] * j}>
                        <Typography component={'span'}>
                          <Box sx={consentBox}>{obj.typeOfConsent}</Box>
                        </Typography>
                      </StyledTableCell>
                    );
                  }
                  return (
                    <StyledTableCell key={obj['id'] * j}>
                      {obj[headerColumnObj.key] || '---'}
                    </StyledTableCell>
                  );
                })}
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default ReusableTable;
